<template>
  <div id="app" class="opened-menu">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
<style>
.ql-editor {
  max-height: 280px;
  overflow: auto;
}

.ql-editor::-webkit-scrollbar {
  width: 0.4em;
}

.ql-editor::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.ql-editor::-webkit-scrollbar-thumb {
  background-color: #111;
  outline: 1px solid slategrey;
}

.loading-holder {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 35px auto 0 auto;
}

.loading-spinner {
  animation-duration: 0.75s;
  animation-iteration-count: infinite;
  animation-name: rotate-forever;
  animation-timing-function: linear;
  height: 24px;
  width: 24px;
  border: 2px solid #000;
  border-right-color: transparent;
  border-radius: 50%;
  display: inline-block;
}

.loading-spinner.white {
  border-top-color: #fff !important;
  border-bottom-color: #fff !important;
  border-left-color: #fff !important;
}

@keyframes rotate-forever {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue